'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const jsxRuntime = require('react/jsx-runtime');

const root = "_root_15s24_1";
const closeButton = "_close-button_15s24_27";
const modalContentHeader = "_modal-content-header_15s24_36";
const modalContentBody = "_modal-content-body_15s24_44";
const modalContentBodyInner = "_modal-content-body-inner_15s24_74";
const modalContentFooter = "_modal-content-footer_15s24_85";
const styles = {
	root: root,
	closeButton: closeButton,
	modalContentHeader: modalContentHeader,
	modalContentBody: modalContentBody,
	modalContentBodyInner: modalContentBodyInner,
	modalContentFooter: modalContentFooter
};

const ModalContentHeader = (props) => {
  return jsxRuntime.jsx("header", { className: styles.modalContentHeader, "data-zds": true, children: props.children });
};
const ModalContentBody = (props) => {
  const { size = props.scrollable ? "small" : "medium" } = props;
  return jsxRuntime.jsx("div", { className: styles.modalContentBody, "data-scrollable": props.scrollable === true ? "" : void 0, "data-size": size, "data-zds": true, children: jsxRuntime.jsx("div", { className: styles.modalContentBodyInner, "data-scrollable": props.scrollable === true ? "" : void 0, tabIndex: props.scrollable === true ? 0 : void 0, "data-zds": true, children: props.children }) });
};
const ModalContentFooter = (props) => {
  return jsxRuntime.jsx("footer", { className: styles.modalContentFooter, children: props.children });
};
const ModalContent = (props) => {
  const style = {
    maxWidth: props.maxWidth
  };
  return jsxRuntime.jsxs("div", { className: styles.root, style, "data-zds": true, children: [props.children, props.closeButton && jsxRuntime.jsx("div", { className: styles.closeButton, children: props.closeButton })] });
};

exports.ModalContent = ModalContent;
exports.ModalContentBody = ModalContentBody;
exports.ModalContentFooter = ModalContentFooter;
exports.ModalContentHeader = ModalContentHeader;
//# sourceMappingURL=ModalContent.cjs.js.map
